<template>
    <div class="worker-page">
        <layout>
            <template v-slot:search>
                <div class="search-wrapper">
                    <div class="title"><a-icon type="search" /> 数据筛选</div>
                    <a-divider></a-divider>
                    <a-space>
                        <a-select show-search placeholder="所属主体" v-model="queryParam.corporation_id"  option-filter-prop="children">
                          <a-select-option :value="corporation.id" v-for="corporation in corporations" :key="corporation.id" >
                            {{ corporation.name }}
                          </a-select-option>
                        </a-select>
                        <a-select show-search allow-clear placeholder="所属小组" v-model="queryParam.team_id"  option-filter-prop="children">
                            <a-select-option :value="team.id" v-for="team in teams" :key="team.id" >
                              {{ team.name }}
                            </a-select-option>
                         </a-select>
                        <a-select show-search allow-clear placeholder="状态" v-model="queryParam.state"  option-filter-prop="children">
                          <a-select-option :value="item.id" v-for="item in status" :key="item.id" >
                            {{ item.name }}
                          </a-select-option>
                        </a-select>
                        <a-select show-search allow-clear placeholder="业务类型" v-model="queryParam.business_type" option-filter-prop="children">
                          <a-select-option :value="item.id" v-for="item in businessTypes" :key="item.id" >
                            {{ item.name }}
                          </a-select-option>
                        </a-select>
                        <a-select show-search allow-clear placeholder="优化师类型" v-model="queryParam.type" option-filter-prop="children">
                          <a-select-option :value="item.id" v-for="item in types" :key="item.id" >
                            {{ item.name }}
                          </a-select-option>
                        </a-select>
                        <a-select show-search allow-clear placeholder="同步素材" v-model="queryParam.is_sync_material" option-filter-prop="children">
                          <a-select-option :value="item.id" v-for="item in syncOptions" :key="item.id" >
                            {{ item.name }}
                          </a-select-option>
                        </a-select>
                      <a-input allow-clear placeholder="姓名" v-model="queryParam.name" />
                      <a-input allow-clear placeholder="钉钉手机号" v-model="queryParam.mobile" />
                      <a-button type="primary" @click="search">查询</a-button>
                      <a-button @click="resetSearch">重置</a-button>
                    </a-space>
                </div>
            </template>

            <template v-slot:content>
                <a-space class="table-operator">
                    <a-button type="primary" icon="plus" @click="create" v-if="accessTo('store')">添加</a-button>
                    <a-button type="primary" icon="setting" @click="batchSyncShow" :disabled="!selectedRowKeys.length" v-if="accessTo('update')">批量设置同步素材</a-button>
                    <span v-if="selectedRowKeys.length">已选中 {{ selectedRowKeys.length }} 人</span>
                </a-space>

                <a-table
                  :columns="columns"
                  :row-key="record => record.id"
                  :data-source="data"
                  :pagination="pagination"
                  :loading="loading"
                  :transform-cell-text="$helper.emptyFormat"
                  :row-selection="rowSelection"
                  @change="handleTableChange"
                >
                    <div slot="action" slot-scope="record" class="actions">
                        <template v-if="accessTo('dingtalkBind')">
                            <a href="javascript:;" @click="dingtalkBind(record)" v-if="accessTo('dingtalkBind')">绑定钉钉</a>
                        </template>
                        <a-divider type="vertical" />
                        <template v-if="accessTo('update')">
                            <a href="javascript:;" @click="create(record)" v-if="accessTo('update')">编辑</a>
                        </template>
                        <template v-else>-</template>
                    </div>

                    <div slot="is_sync_material" slot-scope="record">
                        <a-switch
                            :checked="!!record.is_sync_material"
                            checked-children="开"
                            un-checked-children="关"
                            @change="toggleSyncMaterial(record)"
                            :disabled="!accessTo('update')"
                        />
                    </div>

                    <div slot="teams" slot-scope="teams">
                        <span v-if="teams.length>0">
                          <span v-for="item in teams" :key="item.id">
                            {{item.name}}
                          </span>
                        </span>
                        <span v-else> - </span>
                    </div>

                    <div slot="emails" slot-scope="emails">
                        <span v-if="emails.length>0">
                          <a-tag v-for="(item, index) in emails" :key="index">
                            {{item}}
                          </a-tag>
                        </span>
                        <span v-else> - </span>
                    </div>

                    <div slot="state" slot-scope="state">
                      <a-tag :color="state == 1 ? 'green' : 'red'">
                        {{ state == 1 ? '在职' : '离职' }}
                      </a-tag>
                      </div>
                </a-table>
            </template>
        </layout>
        <create-form
            v-if="showForm"
            :showForm.sync="showForm"
            :model="model"
            @success="refresh"
        />

        <dingtalk-bind-form
            v-if="showDingtalkBindForm"
            :showDingtalkBindForm.sync="showDingtalkBindForm"
            :model="model"
            @success="refresh"
        />

        <batch-sync-form
            v-if="showBatchSyncForm"
            :showBatchSyncForm.sync="showBatchSyncForm"
            :ids="selectedRowKeys"
            @success="refresh"
        />
    </div>
</template>

<style lang="less" scoped>
@import 'Worker';
</style>

<script>
import Worker from './Worker'
export default Worker
</script>
